import React from 'react';
import { Button } from '@mui/material';

const PrimaryButton = ({ children, sx = {}, ...props }) => {
  return (
    <Button
      variant="contained"
      sx={{
        borderRadius: 2,
        px: 4,
        color: '#fff',
        background: '#1a1f37',
        '&:hover': {
          background: '#171C32',
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default PrimaryButton;
